export const nodeTypes = {
  CONFIGURATION: "configuration",
  ANY: "any",
  ROOT: "root",
  TROXNETCOMROOT: "troxNetcomRoot",
  TROXNETCOM_ANY: "troxNetcom",
};

export const configurationTypes = {
  TROXNETCOM: "TroxNetcom",
  CUSTOM: "CustomItem",
  TROXNETCOM_NOTE: "TroxNetcomNote",
};

export const EditNodeTypes = {
  TITLE: "title",
  QUANTITY: "quantity",
};
